module.exports = __webpack_public_path__ + "img/qq.039316d5.jpg";